import React, { useRef, useState, useEffect } from "react";

import styles from "styles.module.css";
import Filter from "./Filter";
import { GridPDFExport } from "@progress/kendo-react-pdf";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { OverLayLoading } from "ui/Loading";
import { useTranslation } from "react-i18next";
import { GridCellProps } from "@progress/kendo-react-grid";
import { PageTypePath } from "utils/pages";
import { PdfType } from "utils/PdfType";

import { useInfoStore } from "store/error";
import { frozenSaleWeeklyGridColumn } from "./utils/GridColumns";
import { FrozenSalesWeeklyFilter, getFrozenSaleWeeklyApi } from "api/sales";
// import FrozenSalesWeeklyGrid from "./GridPage";
// @ts-ignore
import "./style.css";
import GridWithGroupPaging from "ui/grid/GridWithGroupPaging";
//import { addWeeks, addDays } from "date-fns";

const pageSize = 60;

const FrozenSalesWeeklyPage = () => {
	const { t } = useTranslation();
	const overlayRef = useRef<HTMLDivElement>(null);
	const [gridData, setGridData] = useState<any[]>([]);
	const [isLoading, setIsLoading] = useState<boolean>(false);

	const gridRef = useRef<HTMLDivElement>(null);

	const [filterOptions, setFilterOptions] = useState<FrozenSalesWeeklyFilter>({
		// take: pageSize,
		// skip: 0,
		fromDate: new Date(),
		toDate: new Date(),
	});

	const pdfRef = useRef<GridPDFExport>(null);
	const excelRef = useRef<ExcelExport>(null);
	const { setError } = useInfoStore();

	useEffect(() => {
		setIsLoading(true);
		getFrozenSaleWeeklyApi(filterOptions)
			.then((res) => {
				setGridData(res);
			})
			.catch((err) => {
				setError(err);
			})
			.finally(() => {
				setIsLoading(false);
			});
	}, [filterOptions]);

	const exportGridAsPDF = () => {
		if (pdfRef.current !== null) {
			pdfRef.current.save();
		}
	};

	const exportGridAsExcel = () => {
		if (excelRef.current !== null) {
			excelRef.current.save();
		}
	};

	const openPdf = (prop: GridCellProps) => {
		window.open(
			`/${PageTypePath.Pdf}/${prop.dataItem.id}/${PdfType.Contract}`,
			"_blank"
		);
	};

	return (
		<div className={styles.PageContainer}>
			<div ref={overlayRef}>
				<OverLayLoading show={isLoading} />
			</div>
			<div className="page-header">
				<legend className={styles.BoxHeadingLarge}>
					{t("FrozenSalesWeekly")}
				</legend>
			</div>
			<div>
				<Filter
					setFilterOptions={setFilterOptions}
					filterOptions={filterOptions}
					exportAsPDF={exportGridAsPDF}
					exportAsExcel={exportGridAsExcel}
					pageSize={pageSize}
				/>
			</div>
			<div style={{}} ref={gridRef}>
				<GridWithGroupPaging
					gridColumns={frozenSaleWeeklyGridColumn()}
					// filter={filterOptions}
					gridData={gridData}
					exportGridAsPDFRef={pdfRef}
					exportGridAsExcelRef={excelRef}
					// apiMethod={getFrozenSaleWeeklyApi}
					pageable={false}
					// hideVirtualScroll={true}
					// pageable={false}
					excelProps={{
						fileName: `frozen_weekly_sales_${new Date().toISOString()}.xlsx`,
					}}
				/>
			</div>
		</div>
	);
};

export default FrozenSalesWeeklyPage;
